import React from 'react';

const NoDataView = ({ noDataText = 'No data', size = 'small', children }) => {
    return (
        <div className={`no-data-view size-${size}`}>
            <img className='no-data-img' src='../../images/icon/building-crane.svg' alt='no-data' />
            <p className='no-data-text'>{noDataText}</p>
            {children && <div className='content'>{children}</div>}
        </div>
    )
}

export default NoDataView